import AppCatalog from "@/services/App/AppCatalog.js";
import AppModule from "@/services/App/AppModule.js";
import InputType from "@/services/Input/InputType.js";
import OutputType from "@/services/Input/OutputType.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Comment: {
    Label: "Catatan",
    Type: InputType.TextArea,
    MaxLength: 200
  },
  CreatedBy: {
    Label: AppCatalog.Field.CreatedBy.Label,
    Type: AppCatalog.Field.CreatedBy.Type
  },
  CreatedByID: {
    Label: AppCatalog.Field.CreatedByID.Label,
    Type: AppCatalog.Field.CreatedByID.Type,
    RelatedValue: AppCatalog.Field.CreatedByID.RelatedValue,
    RelatedModule: AppCatalog.Field.CreatedByID.RelatedModule
  },
  CreatedDate: {
    Label: AppCatalog.Field.CreatedDate.Label,
    Type: AppCatalog.Field.CreatedDate.Type,
    ReadOnly: AppCatalog.Field.CreatedDate.ReadOnly,
    Output: AppCatalog.Field.CreatedDate.Output,
  },
  Date: {
    Label: "Tanggal",
    Type: InputType.Date,
    ReadOnly: true
  },
  DestinationWarehouseID: {
    Label: "Gudang Akhir",
    Type: InputType.ID,
    Input: InputType.Select,
    Required: true,
    RelatedValue: "DestinationWarehouseName",
    RelatedModule: AppModule.Warehouse,
    RelatedIsActive: "DestinationWarehouseIsActive",
    UnequalTo: "SourceWarehouseID"
  },
  HppTotal: {
    Label: "Harga Pokok Total",
    Type: InputType.Decimal,
    ReadOnly: true,
    Output: OutputType.Decimal.Accounting2D
  },
  SourceWarehouseID: {
    Label: "Gudang Awal",
    Type: InputType.ID,
    Input: InputType.Select,
    Required: true,
    RelatedValue: "SourceWarehouseName",
    RelatedModule: AppModule.Warehouse,
    RelatedIsActive: "SourceWarehouseIsActive",
  },
  StockTrfNumber: {
    Label: "Nomor Transfer",
    PrintLabel: "Nomor",
    Type: InputType.Text,
    MaxLength: 45,
    Highlight: true
  },
  
  // validation
  StockMissingQty: {
    Label: "Qty Stok",
    Type: InputType.Integer,
    MaxValue: 0
  },

  // support
  IsAutoNumber: {
    Label: "Nomor Transfer",
    Type: AppCatalog.Field.IsAutoNumber.Type,
    Output: OutputType.Boolean.AutoManual
  }
}